module.exports = __webpack_public_path__ + "img/prc_pixelrealmtk.2e07762.png";